import { SearchProductsGetRequest, } from 'components/discovery/shared/search/api/search-products-api.js'
import { SearchProductsParser } from 'components/discovery/shared/search/parsers/search-products-parser.js'
import { FilterAttributes } from 'components/discovery/shared/search/typing/filter-attributes.js'
import { SearchResults } from 'components/discovery/shared/search/typing/search-results.js'
import { SearchProductsDatafetcher } from 'components/discovery/shared/search/datafetchers/search-products-datafetcher.js'
import { FilterAttributesParser } from 'components/discovery/shared/search/parsers/filter-attributes-parser.js'
import { FAKE, inject, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { WINDOW_HISTORY, WindowHistory } from '@cloudsuite/mosaic-shared/scripts/window-history.js'
import { createBatch, createSignal } from '@cloudsuite/mosaic-shared/scripts/signals.js'

export const SEARCH_PRODUCTS_STORE = Symbol('SEARCH_PRODUCTS_STORE')

const defaultSearchResults: SearchResults =  {
  totalFound: 0,
  products: [],
  sortModes: [],
  paginator: null,
}

export const defaultAttributes = new FilterAttributes(new Map())

@registerDependency(REAL, SEARCH_PRODUCTS_STORE)
export class SearchProductsStore {

  @inject(WINDOW_HISTORY)
  private history!: WindowHistory

  searchResults: () => SearchResults
  private setSearchResults: (value: SearchResults) => void

  attributes: () => FilterAttributes
  setAttributes: (value: FilterAttributes) => void

  searchIsLoading: () => boolean
  private setSearchIsLoading: (isLoading: boolean) => void

  datafetcher: SearchProductsDatafetcher = new SearchProductsDatafetcher()
  searchProductParser: SearchProductsParser = new SearchProductsParser()
  private filterAttributesParser: FilterAttributesParser = new FilterAttributesParser()

  constructor() {
    [this.attributes, this.setAttributes] = createSignal<FilterAttributes>(defaultAttributes);
    [this.searchResults, this.setSearchResults] = createSignal<SearchResults>(defaultSearchResults);
    [this.searchIsLoading, this.setSearchIsLoading] = createSignal<boolean>(false)
  }

  search = async (path: string) => {
    this.setSearchIsLoading(true)

    const request = new SearchProductsGetRequest(path)
    const response = await this.datafetcher.search(request, this.searchIsLoading())

    this.setSearchIsLoading(false)

    if (response) {
      this.history.replaceQueryFromPath(request.endpointUrl.toString())
      this.setSearchResults(response.searchResults)
      this.setAttributes(this.attributes().merge(response.attributes))
    }
  }

  initializeStoreWithProducts = (initialData: unknown) => {
    let parsedSearchResults: SearchResults
    try {
      parsedSearchResults = this.searchProductParser.parseSearchResultsResponse(initialData)
    } catch (error) {
      this.setSearchIsLoading(false)
      console && console.warn('Could not parse search results', error)
      // error must be passed to sentry
      return
    }
    this.setSearchIsLoading(false)

    const parsedFilterAttributes = this.filterAttributesParser.parseFilterAttributes(initialData)
    if (this.filterAttributesParser.filterAttributeParseResultHasError(parsedFilterAttributes)) {
      console && console.warn('Could not parse filter attributes', parsedFilterAttributes.error)
      // error must be passed to sentry
      return
    }

    createBatch(() => {
      this.setSearchResults(parsedSearchResults)
      this.setAttributes(this.attributes().merge(parsedFilterAttributes))
    })
  }
}

@registerDependency(FAKE, SEARCH_PRODUCTS_STORE)
export class FakeSearchProductsStore extends SearchProductsStore {
  async initializeSearchProductsStore(treePath: string) {
    await this.search(treePath)
  }
}
